import {scrollToEl} from './functions';

(function () {
    if (location.hash) {
        scrollToEl(location.hash, 500);
    }

    document.addEventListener('click', function (e) {
        if (e.target.tagName !== 'A') return false;

        if (e.target.getAttribute('href').startsWith('#')) {
            e.preventDefault();
            scrollToEl(e.target.getAttribute('href'), 200);
        }
    });
})();